<template>
  <div class="modal fade close-view-recording-modal" id="ViewRecordingModal" tabindex="-1" aria-hidden="true" @click="closeModal()">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Gravação</h1>
                  <button type="button" class="btn-close close-view-recording-modal" data-bs-dismiss="modal" @click="closeModal()" aria-label="Close"></button>
              </div>
              
              <div class="modal-body">
                <p class="mb-2"><strong>Nome original:</strong> {{ getCurrentRecording.original_name }} <br>
                  <strong>Nome de conversão:</strong> {{ getCurrentRecording.file_name }} <br>
                  <strong>Data:</strong>  {{ getCurrentRecording.created_at }} <br>
                  <strong>Duração:</strong> {{ getCurrentRecording.duration }} <br>
                  <strong>Tamanho:</strong> {{ getCurrentRecording.size }} <br>
                  <span v-if="getCurrentRecording.sentiment">
                    <strong>Análise de sentimento:</strong> {{ getCurrentRecording.sentiment }}
                  </span>
                </p>

                <div v-if="getCurrentRecording.file_name == null">
                  <span class="badge text-bg-danger fs-13 radius-7">Gravação corrompida</span>
                </div>
                <div v-else>
                  <div v-if="loadingAudioPlayer">
                      <h3>Carregando áudio...</h3>
                  </div>
                  <div v-if="getCurrentRecording.exported_files_id">
                      <br>
                      <h3>O arquivo foi exportado e não se encontra mais em nossa base de dados devido ao encerramento da prestação de serviço. os arquivos foram enviados para o email empresarial</h3>
                      <br>
                  </div>
                  <div class="transcript-container w-100 mb-3">
                    <button v-if="getCurrentRecording.transcribed == 1 && getCurrentTranscription.length == 0" @click="getTranscription()" class="btn btn-primary transcription-button" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                      <i class="flaticon flaticon-comment mr-2"></i> Monstrar transcrição
                    </button>
                    <textarea 
                      id="currentTranscript" 
                      rows="12" 
                      readonly 
                      aria-readonly="true" 
                      v-if="getCurrentTranscription.length > 0" 
                      v-model="getCurrentTranscription"
                    ></textarea>
                  </div>
                  <div>
                      <audio id="playerRecording" controls>
                          <source src="" type="audio/mp3">
                          Your browser does not support the audio element.
                      </audio>
                  </div>
                </div>

              </div>

              <div class="modal-footer">
                  <button type="button" @click="closeModal()" class="btn btn-success w-100 close-view-recording-modal" data-bs-dismiss="modal">Fechar</button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import url from '../../config/recordings.js'; 
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "ViewRecordingModal",
  data () {
    return {
      loadingAudioPlayer: false,
      errorMessage: ""
    }
  },
  computed:{
    ...mapGetters([
        'getCurrentRecording',
        'getCurrentUrlRecording',
        'getCurrentTranscription',
        'getRecordingShowModalState'
    ])
  },
  watch: {
    getRecordingShowModalState(data){
      if(data){
        this.getAudio();
      }
    }
  },
  methods: {
    ...mapActions([
      "setRecordingShowModalState",
      "setTranscription",
      "resetTranscription"
    ]),
    getTranscription(){
      this.setTranscription(this.getCurrentRecording.id);
    },
    closeModal(){
      if (event.target.classList.contains('transcription-button')) {
        this.resetTranscription();
        return;
      }
      console.log("opinha");
      if (event.target.classList.contains('close-view-recording-modal')) {
        if(document.getElementById('playerRecording')){
          document.getElementById('playerRecording').pause();
          document.getElementById('playerRecording').src = null;
        }
        this.resetTranscription();
        this.setRecordingShowModalState(false);
      }
    },
    getUrlBase() {
      return url;
    },
    getAudio(){
      if(this.getCurrentRecording.id == undefined || this.getCurrentRecording.id == null){
        console.log("bateu aqui...");
        return "";
      }

      const audioUrl = `${this.getUrlBase().url}/api/getRecording/${this.getCurrentRecording.id}`;

      const requestOptions = {
        method: 'GET',
        credentials: 'include'
      };

      this.loadingAudioPlayer = true;

      fetch(audioUrl, requestOptions)
      .then(response => {
        if (!response.ok) {
          this.loadingAudioPlayer = false;
          this.errorMessage = "Erro ao carregar áudio, por favor tente novamente mais tarde!";
        }
        this.loadingAudioPlayer = false;
        return response.blob();
      })
      .then(blob => {
        if(document.getElementById('playerRecording')){
          const audioElement = document.getElementById('playerRecording');
          console.log("element será: ", audioElement);
          console.log("url será: ", URL.createObjectURL(blob));
          audioElement.src = URL.createObjectURL(blob);
        }
      })
      .catch(error => {
        console.error('Erro:', error);
      });
    }
  }
};
</script>

<style scoped>
#currentTranscript{
    width: 100%;         
    box-sizing: border-box;
    overflow: auto;      
    resize: none;    
    padding: .5rem;
    background: #f5f5f5; 
    color: #333;
    border: 1px solid #ccc;
    border-radius: 6px;
    cursor: text;        
  }

  #currentTranscript[readonly] {
    opacity: 0.9;
  }
</style>